module.exports = __webpack_public_path__ + "img/backgroundImg2.bbc9d13.webp";